<template>
    <div class="dashboard-wrapper">
      <h1 class="title">Dashboard</h1>
      <div class="columns dashboard">

        <div class="column"
             :class="{ 'is-two-thirds': !isTrucklAdmin }"
        >
          <div class="card">

            <div class="card-header-title">
            </div>

            <div class="card-content">
              <shipper-dashboard v-if="isShipper" />
              <carrier-dashboard v-if="isCarrier" />
              <factoring-dashboard v-if="isFactoring" />
              <truckl-admin-dashboard v-if="isTrucklAdmin" />
            </div>
          </div>
        </div>

        <div class="column" v-if="!isTrucklAdmin">
          <div class="card">
            <div class="card-header-title">
              Transaction Visualization
            </div>
            <div class="card-content">
              <transactions-map />
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import ShipperDashboard from '@/components/Dashboard/Shipper'
import CarrierDashboard from '@/components/Dashboard/Carrier'
import FactoringDashboard from '@/components/Dashboard/Factoring'
import TrucklAdminDashboard from '@/components/Dashboard/TrucklAdmin'
import TransactionsMap from '@/components/Dashboard/TransactionsMap'

export default {
  name: 'Dashboard',

  created() {
    if (this.justRegistered) {
      this.$store.commit('SET_REGISTRATION_FLAG', false)
      this.$snackbar.open({
        message: 'You are now all setup and ready to start using Truckl. Welcome to The Road to Trust!',
        position: 'is-top',
        actionText: 'Thank You!'
      })
    }
  },

  computed: {
    ...mapState(['justRegistered']),
    ...mapGetters('user', ['isShipper', 'isFactoring', 'isCarrier', 'isTrucklAdmin']),
    ...mapState('user', ['tokens', 'currentUserInfo']),
    formatedExpirationTime() {
      return format(this.tokens.expiresAt, 'YYYY-MMM-DD hh:MM:ss A Z')
    }
  },

  components: {
    ShipperDashboard,
    CarrierDashboard,
    FactoringDashboard,
    TrucklAdminDashboard,
    TransactionsMap
  }
}
</script>

<style scoped lang="scss">
.dashboard-wrapper {
  // these negative margins are to counter those of the `.container` class on the Portal view so the dashboard can use
  // more of the screen
  margin-left: -95px;
  margin-right: -95px;

  &::after {
    // TODO: this would be great as a mix-in
    content: '';
    background-image: url('../../assets/backgrounds/shutterstock_758444896.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}

$mobile: '768px';
.wrapper {
  // height: 100vh;
  // overflow: hidden;
  margin: 0;
}

@media (max-width: $mobile) {
  .wrapper {
    // overflow: auto;
  }
}

.main-content-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-items: stretch;
  margin: 0;
  padding: 0;

  > div {
    display: flex;
  }
}

.header {
  height: 60px;
  padding: 0 16px;
  // background-color: rgb(33, 57, 101);
  // box-shadow: 15px -8px 20px 0px rgb(33, 57, 101);
  //margin: 0 25px;
  margin: 0;
}

@media (max-width: $mobile) {
  .header {
    height: 30px;
    margin: 10px 0;
  }
}

.main {
  overflow: auto;
  flex: 1;
  padding: 0 25px;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
}

.logo {
  width: 85%;
  margin: 0 auto 50px auto;
}

.aside {
  // background: #2e363f;
  background-color: rgb(249, 249, 255);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-around;
  box-shadow: -8px 0 20px 0px rgb(33, 57, 101);
}

.aside-content {
  margin: 16px 0;
  flex: 1;
}

.user-menu {
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>
